var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasskeyChrome24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 13.498C11.4853 13.498 13.5 11.4833 13.5 8.99801C13.5 6.51273 11.4853 4.49801 9 4.49801C6.51472 4.49801 4.5 6.51273 4.5 8.99801C4.5 11.4833 6.51472 13.498 9 13.498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 4.49999H16.7929C16.0033 3.13176 14.8673 1.99556 13.4992 1.20562C12.1311 0.415685 10.5792 -0.00013309 8.9994 -2.28663e-05C7.41964 8.7357e-05 5.86775 0.416122 4.49978 1.20625C3.1318 1.99637 1.99597 3.13274 1.20648 4.50108L5.10296 11.25L5.10644 11.2491C4.71007 10.5656 4.5009 9.78963 4.50001 8.99949C4.49912 8.20935 4.70655 7.43295 5.10139 6.74853C5.49622 6.06412 6.06451 5.49589 6.74897 5.10113C7.43343 4.70637 8.20986 4.49902 8.99999 4.49999Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5625C10.9675 12.5625 12.5625 10.9675 12.5625 9C12.5625 7.03249 10.9675 5.4375 9 5.4375C7.03249 5.4375 5.4375 7.03249 5.4375 9C5.4375 10.9675 7.03249 12.5625 9 12.5625Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8967 11.2511L9.00024 18C10.58 18.0002 12.132 17.5845 13.5001 16.7947C14.8682 16.0048 16.0043 14.8687 16.7941 13.5006C17.5839 12.1324 17.9995 10.5804 17.9992 9.00065C17.9989 7.42089 17.5827 5.86905 16.7925 4.50117H8.99956L8.99863 4.50465C9.78877 4.50313 10.5653 4.70994 11.2501 5.10424C11.9348 5.49853 12.5035 6.06637 12.8988 6.75052C13.2941 7.43467 13.502 8.21094 13.5017 9.00108C13.5013 9.79123 13.2926 10.5673 12.8967 11.2511Z",
    fill: "url(#paint1_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10324 11.2512L1.20676 4.50224C0.416682 5.87024 0.000699748 7.42215 0.000640875 9.00191C0.000582002 10.5817 0.416449 12.1336 1.20643 13.5017C1.9964 14.8697 3.13264 16.0057 4.5009 16.7953C5.86915 17.585 7.42119 18.0004 9.00095 18L12.8974 11.2511L12.8949 11.2485C12.5011 11.9336 11.9338 12.5027 11.2499 12.8985C10.5661 13.2944 9.78997 13.5029 8.99983 13.5032C8.20969 13.5035 7.43345 13.2954 6.74934 12.9C6.06524 12.5047 5.49746 11.9359 5.10324 11.2512Z",
    fill: "url(#paint2_linear_0_4)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 1.20648,
    y1: 5.62499,
    x2: 16.7929,
    y2: 5.62499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 7.77069,
    y1: 17.8797,
    x2: 15.5639,
    y2: 4.38139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_4",
    x1: 9.9743,
    y1: 17.4381,
    x2: 2.18105,
    y2: 3.93974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasskeyChrome24);
export default __webpack_public_path__ + "static/media/icon-passkey-chrome-24.e26a6cf6dbcb4e9c3f904120d6b06011.svg";
export { ForwardRef as ReactComponent };